import { React, useState, useEffect } from "react";
import { InformationsWrapper } from "../customersPage.styled";
import { getInvestments } from "../customersUtils";
import CustomersTable from "./customersTable";
import { InvestmentCells } from "../data";
import { toast } from "react-toastify";
import { Backdrop, CircularProgress } from "@mui/material";
import { useParams } from "react-router";

function Investment() {
	const { id } = useParams();
	const [data, setData] = useState([]);
	const [loading, setLoading] = useState(true);
	const [selected, setSelected] = useState([]);

	useEffect(() => {
		getInvestments(id)
			.then((res) => {
				if (res.error) {
					setLoading(false);
					toast.error(res.error);
				} else if (res.result) {
					setLoading(false);
					// console.log(res.result);
					setData(res.result);
				} else {
					setLoading(false);
					toast.error("Unable to fetch user investments");
				}
			})
			.catch((error) => {
				setLoading(false);
				console.log(error);
				toast.error(error);
			});
	}, []);

	return (
		<InformationsWrapper>
			<p className='avatar mb-6'>
				<img src='/images/investment_img.svg' alt='transaction image' />
			</p>

			<CustomersTable
				headCells={InvestmentCells}
				TableData={data}
				setSelected={setSelected}
				selected={selected}
			/>
			{loading && (
				<Backdrop
					sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
					open={loading}
				>
					<CircularProgress color='inherit' />
				</Backdrop>
			)}
		</InformationsWrapper>
	);
}

export default Investment;
